import { ArrowRightGlobalNavigation } from 'src/components/icons/ArrowRightGlobalNavigation'
import { useMenu } from 'src/contexts/menu-context'
import Logo from '../../../Common/Logo'
import { LEVELS } from '../../../constants'
import type { MenuSectionProps } from '../../../global-navigation'
import {
  hasNextLevel,
  isItemInPath,
  trackMenuPathDesktop,
} from '../../../utils'
import { Item } from './MenuSectionItem/Item'

export const MenuSection = ({ menu, type }: MenuSectionProps) => {
  const { state, handleDispatch } = useMenu()

  return (
    <div className="pb-2 border-b-2 border-solid border-[#F0F0F0] [&>a:last-child]:mb-0 mb-3">
      {menu?.map((el) => {
        return !hasNextLevel(el) ? (
          <a
            key={`section-item-${el.index}`}
            href={el.titleURL ? el.titleURL : undefined}
            className={`py-3 flex flex-row gap-3 items-center justify-between mb-1 px-6 rounded-lg overflow-hidden transition-all ${
              isItemInPath(state, LEVELS.main, el.index) ? 'bg-yellow' : ''
            } navigation-link-panel cursor-pointer ${
              el.tag && el.tag !== null ? 'relative' : ''
            }`}
            data-category={`data-${el.title}`}
            onMouseEnter={() => {
              if (
                type &&
                el.index !== undefined &&
                el.title &&
                el.title !== null
              ) {
                hasNextLevel(el)
                  ? handleDispatch(type, el.index, el.title, Number(type) + 1)
                  : handleDispatch(type, el.index, el.title, Number(type))
              }
            }}
            onClick={() => trackMenuPathDesktop(Number(type), state)}
          >
            <div className="flex flex-row gap-2 items-center max-w-[calc(100%-36px)]">
              <Logo logo={el.logoImage ?? ''} label={el.title ?? ''} />
              <div className="max-w-full overflow-hidden">
                <Item item={el} />
              </div>
            </div>
            {el.tag && (
              <span
                style={{ backgroundColor: el.tagColor ?? '' }}
                className={`block absolute top-2 right-0 rounded-sm text-white px-1.5 text-xs !leading-[20px] tracking-[-0.108px] font-[700]`}
              >
                {el.tag}
              </span>
            )}
            {hasNextLevel(el) && el.isDesktop && (
              <span className="block w-6 h-6">
                <ArrowRightGlobalNavigation />
              </span>
            )}
          </a>
        ) : (
          <div
            key={`section-item-${el.index}`}
            className={`py-3 flex flex-row gap-3 items-center justify-between mb-1 px-6 rounded-lg overflow-hidden transition-all ${
              isItemInPath(state, LEVELS.main, el.index) ? 'bg-yellow' : ''
            } navigation-link-panel cursor-pointer ${
              el.tag && el.tag !== null ? 'relative' : ''
            }`}
            data-category={`data-${el.title}`}
            onMouseEnter={() => {
              if (
                type &&
                el.index !== undefined &&
                el.title &&
                el.title !== null
              ) {
                hasNextLevel(el)
                  ? handleDispatch(type, el.index, el.title, Number(type) + 1)
                  : handleDispatch(type, el.index, el.title, Number(type))
              }
            }}
          >
            <div className="flex flex-row gap-2 items-center max-w-[calc(100%-36px)]">
              <Logo logo={el.logoImage ?? ''} label={el.title ?? ''} />
              <div className="max-w-full overflow-hidden">
                <Item item={el} />
              </div>
            </div>
            {el.tag && (
              <span
                style={{ backgroundColor: el.tagColor ?? '' }}
                className={`block absolute top-2 right-0 rounded-sm text-white px-1.5 text-xs !leading-[20px] tracking-[-0.108px] font-[700]`}
              >
                {el.tag}
              </span>
            )}
            {hasNextLevel(el) && el.isDesktop && (
              <span className="block w-6 h-6">
                <ArrowRightGlobalNavigation />
              </span>
            )}
          </div>
        )
      })}
    </div>
  )
}
